export default class Disability {

  static readonly PHYSICAL  = new Disability('PHYSICAL', "disability.physical");
  static readonly HEARING  = new Disability('HEARING', "disability.hearing");
  static readonly VISION  = new Disability('VISION', "disability.vision");
  static readonly SOCIAL_EMOTIONAL  = new Disability('SOCIAL_EMOTIONAL', "disability.socialEmotional");
  static readonly INTELLECTUAL_DEVELOPMENTAL_COGNITIVE = new Disability('INTELLECTUAL_DEVELOPMENTAL_COGNITIVE', "disability.intellectualDevelopmentalCognitive");
  static readonly DND  = new Disability('DND', "common.dnd");

  static all(){
  	return [
  		Disability.PHYSICAL,
      Disability.HEARING,
      Disability.VISION,
      Disability.SOCIAL_EMOTIONAL,
      Disability.INTELLECTUAL_DEVELOPMENTAL_COGNITIVE,
      Disability.DND
  	]
  }

  // private to disallow creating other instances of this type
  private constructor(public readonly key: string, public readonly label: any) {
  }

  toString() {
    return this.key;
  }
}
